import * as service from './service'
export default {
  namespace: 'walletServiceFeeDetails',
  state: {
    demoData: {}
  },
  effects: {
    * getData ({ payload }, { call, put }) {
      const res = yield call(service.courierServiceFee, payload)
      return res
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
